import { Injectable } from '@angular/core';
import { Store } from '@core/classes/store.class';
import { BaseParamsDTO } from '@core/interfaces/dto/base-params-dto.interface';
import { FrazaForCreationDTO } from '@core/interfaces/dto/creation/fraza-for-creation-dto.interface';
import { FrazaForUpdateDTO } from '@core/interfaces/dto/update/fraza-for-update-dto.interface';
import { Fraza } from '@core/interfaces/models/fraza.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class FrazatService extends Store<Fraza, BaseParamsDTO, FrazaForCreationDTO, FrazaForUpdateDTO> {
  constructor(apiService: ApiService) {
    super(apiService, 'frazat/');
  }

  /**
   * Gets value of phrase by name
   * @param emri name of the phrase
   */
  fn(shkurtimi: string) {
    return this._store$.value.find((x) => x.shkurtimi === shkurtimi)?.pershkrimi;
  }
}
